var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8317 1.06564L11.0028 0.246559C10.7785 0.0222596 10.4079 0.0222596 10.1739 0.246559L6.03898 4.38137L1.82616 0.168542C1.60176 -0.055855 1.23118 -0.055855 0.997229 0.168542L0.168297 0.997473C-0.0560991 1.22177 -0.0560991 1.59235 0.168297 1.8264L4.37147 6.02957L0.246314 10.1742C0.0220155 10.3985 0.0220155 10.7691 0.246314 11.0032L1.07525 11.8321C1.29954 12.0564 1.67013 12.0564 1.90418 11.8321L6.03898 7.69719L10.1739 11.8321C10.3982 12.0564 10.7688 12.0564 11.0028 11.8321L11.8317 11.0032C12.056 10.7789 12.056 10.4083 11.8317 10.1742L7.68709 6.03933L11.822 1.90452C12.056 1.67027 12.056 1.29969 11.8317 1.06564Z",
    fill: "#FF647C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.3adbd707f2ee785ca4826b43005fa4f5.svg";
export { ForwardRef as ReactComponent };